// extracted by css-extract-rspack-plugin
export default {"cls1":"FilterBar-cls1_wRQ","cls2":"FilterBar-cls2_hYQ FilterBar-cls1_wRQ"};